import { Col, Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";

import CustomAvatar from "../../shared/custom-avatar/custom-avatar";
import { TestimonialData, TESTIMONIALS_DATA } from "../../constants/content/shared/testimonials";

import "./styles.scss";
import CustomRow from "../../shared/costum-row/costum-row";
import { TESTIMONIAL_ICON } from "../../constants/svgs";
import PersonInfo from "../person-info/person-info";

const { Title, Text } = Typography;

interface TestimonialProps {
  testimonial?: TestimonialData;
}

const Testimonial: React.FC<TestimonialProps> = ({ testimonial }) => {
  const currentTestimonial = testimonial || TESTIMONIALS_DATA[0];
  const authorDisplay = currentTestimonial.position && currentTestimonial.company 
    ? `${currentTestimonial.author}, ${currentTestimonial.position}`
    : currentTestimonial.author;

  return (
    <div className="Testimonial">
      {TESTIMONIAL_ICON}
      <Text className="Testimonial-info">
        {currentTestimonial.text}
      </Text>

      <PersonInfo name={authorDisplay} />
    </div>
  );
};

export default Testimonial;
